import { unreachable } from '../utils/unreachable';

export enum Priority {
  Normal = 3,
  High = 2,
  Highest = 1,
}

export function getPriorityLabel(status: Priority, t: (key: string) => string): string {
  switch (status) {
    case Priority.Normal:
      return t('Normal');
    case Priority.High:
      return t('High');
    case Priority.Highest:
      return t('Highest');
    default:
      return unreachable(status);
  }
}
